import { StylovyzeIconProps } from '@innovyze/stylovyze';
import { Path } from '@innovyze/stylovyze';
import React from 'react';


const MapIcon: React.FC<StylovyzeIconProps> = ({
	color,
	...props
}: StylovyzeIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="25"
			height="25"
			fill="none"
			viewBox="0 0 25 25"
			{...props}
		>
			<Path
				fill={color}
				color={color}
				fillRule="evenodd"
				d="M8.907 7.265v12.33l-4.27-1.774V5.487l4.27 1.778zm5.24-1.78V17.82l-4.274 1.784V7.269l4.273-1.783zm.486 13.178l5.728 2.376V6.614l-5.729-2.377-5.237 2.185L3.672 4.04v14.426l5.73 2.38 5.232-2.182zm.48-13.182l4.282 1.778v12.334l-4.283-1.777V5.48z"
				clipRule="evenodd"
			/>
		</svg>
	);
};


export default MapIcon;